import { render, staticRenderFns } from "./AlliedLogModal.vue?vue&type=template&id=c48046de&"
import script from "./AlliedLogModal.vue?vue&type=script&lang=js&"
export * from "./AlliedLogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports